import { render } from "./AccountLogin.vue?vue&type=template&id=225f8a49"
import script from "./AccountLogin.vue?vue&type=script&lang=js"
export * from "./AccountLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__